import { configureStore } from '@reduxjs/toolkit'

import monitorReducersEnhancer from './enhancers/monitorReducer'
import dataService from './middleware/data-service'
import loggerMiddleware from './middleware/logger'
import rootReducer from './reducers'

export default function setupStore(preloadedState) {
    return configureStore({
        reducer: rootReducer,
        // thunk er inkludert i RTK sin getDefaultMiddleware() automatisk.
        // dataService og loggerMiddleware beholdes uendret.
        middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(dataService, loggerMiddleware),
        // monitorReducersEnhancer beholdes uendret.
        enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(monitorReducersEnhancer),
        preloadedState
    })
}
